import React from 'react';

const styles = {
    details: { fontSize: '0.75em' },
    highlightProdName: { fontWeight: 'bold' },
};

export function OrderRowNameAndDetails(props) {
    const orderrow = props.orderrow;
    const mobile = props.mobile;

    return (
        <React.Fragment>
            <span style={styles.highlightProdName}>
                {orderrow.product ? orderrow.product.productName : orderrow.productBundle.name}
            </span>
            {!mobile &&
                orderrow.productBundle &&
                orderrow.productBundle.products.map((prod) => (
                    <span style={styles.details} key={prod.product.id}>
                        <br />
                        {prod.productCount} x {prod.product.productName}
                    </span>
                ))}
            {!mobile && orderrow.filterAdditionalInfo && (
                <span style={styles.details}>
                    <br />
                    <em>{orderrow.filterAdditionalInfo}</em>
                </span>
            )}
        </React.Fragment>
    );
}
